<template>
  <div>
    <div id="notification">
      <div id="icon" v-html="icon"></div>
      <span v-if="htmlMessage" id="htmlMessage" v-html="htmlMessage"/>
      <span v-else id="message"><slot>Error</slot></span>
    </div>
  </div>
</template>

<script>
    export default {
        name: "ErrorMessage",
        props: {
          level: {
            type: String,
            default: 'info',
            validator (value) {
              return ['success', 'warning', 'error'].indexOf(value) !== -1
            }
          },
          htmlMessage: {
            type: String,
            default: ''
          }
        },
        mounted() {
          window.scrollTo(0,document.body.scrollHeight);
        },
      computed: {
          icon () {
            switch (this.level) {
              case 'success':
                return '<i class="fa fa-check-circle" style="color: #00b137"></i>'
              case 'warning':
                return '<i class="fa fa-exclamation-circle" style="color: #ffca00"></i>'
              case 'error':
                return '<i class="fa fa-exclamation-circle" style="color: #eb3323" ></i>'
              default:
                return ''
            }
          }
        }
    }
</script>

<style scoped>
  #icon {
    font-size: 50px;
    display: inline-block;
    margin-right: 15px;
  }

  #htmlMessage,
  #message{
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-flow: wrap;
  }

  #notification  {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Notification.vue